/**
 * Audit log API on the same backend (`/api/audit-logs`, …).
 * See {@link backendUrl} in `src/config/backend.ts`.
 */
import { backendUrl } from './backend';
/** Build audit log API URL. */
export function auditLogApiUrl(pathFromSlash) {
    const rel = pathFromSlash.startsWith('/') ? pathFromSlash : `/${pathFromSlash}`;
    return backendUrl(rel);
}
